<div #clientScriptViewContainer></div>
